<div class="row" *ngIf="!haveNoData">
  <div class="col-md-12 col-sm-12" *ngIf="data.kpi">
    <div class="row interaction-figure">
      <div class="col-sm-3">
        <div class="d-flex flex-row flex-auto post-block">
          <div class="d-flex flex-column flex-auto interaction-key-val-box">
            <div class="interaction-key-name">
              {{'measure.interactions.posts' | translate}}
            </div>
            <div class="interaction-key-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.interaction_post_count' | translate}}">
                {{data.kpi.post | thousandNumberSuffix:1}}
              </span>
            </div>
          </div>
          <div class="interaction-seperation-line"></div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="d-flex flex-row flex-auto audience-block">
          <div class="d-flex flex-column flex-auto interaction-key-val-box">
            <div class="interaction-key-name">
              {{'measure.interactions.average_followers' | translate}}
            </div>
            <div class="interaction-key-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.interaction_avg_audience' | translate}}">
                {{data.kpi.audience | thousandNumberSuffix:1}}
              </span>
            </div>
          </div>
          <div class="interaction-seperation-line"></div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="d-flex flex-row flex-auto avg-interact-block">
          <div class="d-flex flex-column flex-auto interaction-key-val-box">
            <div class="interaction-key-name">
              {{'measure.interactions.average_interactions' | translate}}
            </div>
            <div class="interaction-key-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.interaction_avg_int' | translate}}">
                {{data.kpi.interaction | thousandNumberSuffix:1}}
              </span>
            </div>
          </div>
          <div class="interaction-seperation-line"></div>
        </div>
      </div>
      <div class="col-sm-3">
        <div class="d-flex flex-row flex-auto share-block">
          <div class="d-flex flex-column flex-auto interaction-key-val-box">
            <div class="interaction-key-name">
              {{'measure.interactions.average_share' | translate}}
              <achoo-icon-tooltip tooltipMsg="{{'info_box.measure.interaction_rate_info' | translate}}"></achoo-icon-tooltip>
            </div>
            <div class="interaction-key-value">
              <span placement="bottom"
                    ngbTooltip="{{'info_box.measure.interaction_avg_share' | translate}}">
                {{data.kpi.share | formatInteractionPercentage}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="col-md-12">
    <div class="seperation-line-interact-report"></div>
  </div>
  <div class="col-md-12 col-sm-12" *ngIf="shouldShowHeader">
    <div class="d-flex flex-row flex-auto interaction-report-header-line">
      <div class="d-flex post-details-col">
        <div class="interaction-header col-index">#</div>
        <div class="interaction-header influencer-post-col text-uppercase">{{'measure.interactions.influencer_post' | translate}}</div>
      </div>
      <div class="d-flex audience-col">
        <span class="interaction-header">{{'measure.interactions.followers' | translate}}</span>
      </div>
      <div class="d-flex interaction-col">
        <span class="interaction-header">{{'measure.interactions.interactions' | translate}}</span>
      </div>
      <div class="d-flex percentage-col">
        <span class="interaction-header">{{'measure.interactions.percentage' | translate}}</span>
      </div>
    </div>
  </div>
  <div class="col-md-12 col-sm-12"
       *ngFor="let interaction of data.posts; let i = index">
    <div class="d-flex flex-auto interaction-row" [ngClass]="{'even': i % 2 === 0, 'odd' : i % 2 !== 0}">
      <interaction-report-item class="d-flex flex-auto full-width"
                               [interactionPost]="interaction"
                               [pageOrderNo]="pageIndex"
                               [index]="calculateIndex(i)">
      </interaction-report-item>
    </div>
  </div>
  <div class="col-md-12">
    <div class="d-flex justify-content-end interaction-report-pagination" *ngIf="!isExportingPdfReport">
      <achoo-pagination [minPage]="1" [maxPage]="maxPage" (pageChange)="onChangePage($event)"></achoo-pagination>
    </div>
  </div>
</div>
<div *ngIf="haveNoData" class="message">
  <span>{{'measure.noData' | translate}}</span>
</div>



// WEBPACK FOOTER //
// ./src/app/main/measure/contents/interaction-report/interaction-report.component.html